import {TORRESOWO_URL} from "../../utils/consts";
import {SquadflixHeaderNewsItem} from "./types";

export class SquadflixApi {
    static async getSquadflixHeaderNews(): Promise<SquadflixHeaderNewsItem[]> {
        try {
            const res = await fetch(TORRESOWO_URL + '/squadflix/header_news.txt');
            // line format: 1,84XPpjGvxNyExjSuLQe0SzioErt.jpg,chw44B2VnLha8iiTdyZcIW0ZELC.png,,Temporada 5 el 15 Diciembre,Squadflix Original
            const text = await res.text();
            const lines = text.split('\n').filter(line => line.trim().length > 0);
            return lines.map(line => {
                const parts = line.split(',');
                return {
                    order: parseInt(parts[0], 10),
                    backgroundUrl: parts[1],
                    logoImageUrl: parts[2],
                    title: parts[3] || undefined,
                    subtitle: parts[4] || undefined,
                    bottomLeftOverlay: parts[5] || undefined,
                    type: parts[6] || undefined,
                    tmdbId: parts[7] ? parseInt(parts[7], 10) : undefined,
                };
            });
        } catch (error) {
            console.error('Error fetching Squadflix header news:', error);
            return [];
        }
    }
}
